import type { ReactNode } from "react";
import { cn } from "~/shared/lib/utils";

type AuthPageHeaderProps = {
  title: ReactNode;
  description?: ReactNode;
  eyebrow?: ReactNode;
  align?: "center" | "left";
};

export function AuthPageHeader({
  title,
  description,
  eyebrow,
  align = "left",
}: AuthPageHeaderProps) {
  const isCentered = align === "center";

  return (
    <div
      className={cn(
        "flex flex-col gap-2.5",
        isCentered ? "items-center text-center" : "items-start text-left",
      )}
    >
      {eyebrow ? (
        <p className="text-muted-foreground text-xs font-medium uppercase tracking-[0.18em]">
          {eyebrow}
        </p>
      ) : null}
      <div className="space-y-1.5">
        <h1 className="text-xl font-semibold tracking-tight sm:text-2xl">{title}</h1>
        {description ? (
          <div className="text-muted-foreground max-w-[34rem] text-sm leading-6">
            {description}
          </div>
        ) : null}
      </div>
    </div>
  );
}
